import { useNavigate } from 'react-router-dom'
import TableFilter from './tableFilter'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import ExportButton from '../../common/ExportButton'
import { appGetAllSponsor } from '../../store/sponsor'
import { sponsorExportColumns } from '../../config/exportColumns/sponsorExportColumns'

function Sponsor() {
	const navigate = useNavigate()
	const dispatch = useDispatch()

	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')

	const [exportFilters, setExportFilters] = useState({})

	return (
		<>
			<div className="content-wrapper">
				<div className="content-heading d-flex justify-content-between">
					<div>Sponsors and advertisements</div>

					<div className="d-flex gap-2">
						<ExportButton
							fetchAction={params =>
								dispatch(
									appGetAllSponsor({
										...params,
										...exportFilters,
										hubadmin: true,
										hub: hubId || permissionOfHub,
										loading: false,
									}),
								)
							}
							columns={sponsorExportColumns}
							fileName="Sponsors"
							sheetName="Sponsor List"
							buttonText="Export Sponsors"
						/>

						<button
							className="btn btn-labeled btn-success"
							type="button"
							style={{ fontSize: '17px', marginLeft: '10px' }}
							onClick={() => navigate('/sponsor/new')}
						>
							<span className="btn-label">
								<em className="fas fa-plus"></em>
							</span>
							New Sponsor
						</button>
					</div>
				</div>

				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default Sponsor
